import React from 'react'

import { Box, Typography } from "@mui/material"


export default function executionDateColumn() {

	return {
		name: 'timestamp_last_execution',
		label: 'Last Execution',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography>{value}</Typography>
			</Box>,
		}
	}
}